<template>
    <div class="conference">
        <!-- logo -->
        <div class="header hidden-xs-only">
            <div class="header_box section">
                <div class="header_left" @click="goMainIndex">
                    <img src="../assets/images/logo.png" />
                </div>
                <div class="header_right">
                    <div class="header_right_item">
                        <div class="header_right_item_left">
                            <img src="../assets/images/chinese.png" alt />
                        </div>
                        <div class="header_right_item_right">中文版</div>
                    </div>
                    <div class="header_right_line"></div>
                    <div class="header_right_item" @click="changeLanguage">
                        <div class="header_right_item_left">
                            <img src="../assets/images/english.png" alt />
                        </div>
                        <div class="header_right_item_right header_right_item_eng">ENGLISH</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- menu_mobile -->
        <div class="menu_mobile hidden-sm-and-up">
            <div class="menu_mobile_box section">
                <div class="menu_mobile_box_box">
                    <div class="menu_mobile_left" @click="goMainIndex">
                        <img src="../assets/images/logo.png" alt />
                    </div>
                    <div class="menu_mobile_right" @click="openMenuMobile">
                        <img src="../assets/images/menu.png" alt />
                    </div>
                </div>
            </div>
        </div>
        <!-- 导航栏 -->
        <div class="menu hidden-xs-only">
            <div class="menu_box section">
                <div class="header-item" v-for="item in categoryList" :key="item.id">
                    <div class="header-item-name">
                        <div
                            :class="
                                item.children && item.children.length
                                    ? 'header-item-name-icon'
                                    : ''
                            "
                            @click="goPage(item)"
                        >{{ item.name }}</div>
                        <i class="el-icon-arrow-down" v-if="item.children && item.children.length"></i>
                    </div>
                    <div class="dropdown" v-if="item.children && item.children.length">
                        <div
                            @click="goList(item, item2)"
                            v-for="item2 in item.children"
                            :key="item2.id"
                        >{{ item2.typeName }}</div>
                    </div>
                    <div class="header-item-line" v-if="item.id == activeId"></div>
                </div>
            </div>
        </div>
        <!-- main -->
        <div class="main">
            <router-view :key="$route.path"></router-view>
        </div>
        <div class="footer hidden-xs-only">
            <div class="footer_bottom">
                <div class="footer_bottom_box section">
                    <div class="footer_bottom_top">
                        <div
                            class="footer_bottom_top_item"
                            v-for="(item, index) in footerList"
                            :key="index"
                        >
                            <div
                                class="footer_bottom_top_item_top"
                                @click="goItem(item.name)"
                            >{{ item.name }}</div>
                            <div class="footer_bottom_top_item_box">
                                <div
                                    class="footer_bottom_top_item_box_item"
                                    @click="goList(item, items)"
                                    v-for="(items, index) in item.children"
                                    :key="index"
                                >{{ items.typeName }}</div>
                            </div>
                        </div>
                        <div class="footer_bottom_top_item">
                            <div class="footer_bottom_top_item_top" @click="goItem('下载中心')">下载中心</div>
                            <div class="footer_bottom_top_item_item" @click="goItem('优秀品牌')">优秀品牌</div>
                            <div class="footer_bottom_top_item_item" @click="goItem('联系联盟')">联系联盟</div>
                        </div>
                    </div>
                    <div class="footer_bottom_bottom">
                        <div class="footer_bottom_bottom_item">
                            版权所有：国家动物健康与食品安全创新联盟 All Rights
                            Reserved
                        </div>
                        <div
                            class="footer_bottom_bottom_item"
                            @click="
                                goWeb(
                                    'https://beian.miit.gov.cn/#/Integrated/index'
                                )
                            "
                        >ICP备案号：京ICP备20012509号-2</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- mobile_footer -->
        <div class="mobile_footer hidden-sm-and-up">
            <div class="mobile_footer_menu">
                <div class="mobile_footer_menu_box section">
                    <div class="mobile_footer_menu_top">
                        <el-collapse v-model="footerActiveNames">
                            <el-collapse-item
                                :title="item.name"
                                :name="item.id"
                                v-for="(item, index) in footerList"
                                :key="index"
                            >
                                <div
                                    @click="goList(item, items)"
                                    v-for="(items, index) in item.children"
                                    :key="index"
                                >{{ items.typeName }}</div>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                    <div class="mobile_footer_menu_middle">
                        <div class="mobile_footer_menu_middle_item" @click="goItem('下载中心')">下载中心</div>
                        <div class="mobile_footer_menu_middle_item" @click="goItem('优秀品牌')">优秀品牌</div>
                        <div class="mobile_footer_menu_middle_item" @click="goItem('联系联盟')">联系联盟</div>
                    </div>
                    <div class="mobile_footer_menu_bottom">
                        <div class="mobile_footer_menu_bottom_item mobile_footer_menu_bottom_first">
                            版权所有：国家动物健康与食品安全创新联盟 All Rights
                            Reserved
                        </div>
                        <div
                            class="mobile_footer_menu_bottom_item"
                            @click="
                                goWeb(
                                    'https://beian.miit.gov.cn/#/Integrated/index'
                                )
                            "
                        >ICP备案号：京ICP备20012509号-2</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 手机端菜单 -->
        <el-drawer
            title="导航栏"
            size="60%"
            :visible.sync="isOpenMenuMobile"
            :with-header="false"
            :before-close="handleClose"
        >
            <div class="mobile_menu_box">
                <div class="mobile_menu_box_top">
                    <i class="el-icon-close" @click="handleClose"></i>
                </div>
                <div class="mobile_menu_box_bottom">
                    <div class="mobile_menu_box_bottom_bottom">
                        <div class="menu_item" :class="activeId==1?'active':''" @click="goPage({id:1,path:'/conference/index'})">会议首页</div>
                        <el-collapse v-model="topActiveNames">
                            <el-collapse-item
                                :title="item.name"
                                :name="item.id"
                                v-for="(item, index) in footerList"
                                :key="index"
                            >
                                <div
                                    @click="goList(item, items)"
                                    v-for="(items, index) in item.children"
                                    :key="index"
                                >{{ items.typeName }}</div>
                            </el-collapse-item>
                        </el-collapse>
                        <div class="menu_item" :class="activeId==107?'active':''" @click="goItem('下载中心')">下载中心</div>
                        <div class="menu_item" :class="activeId==108?'active':''" @click="goItem('优秀品牌')">优秀品牌</div>
                        <div class="menu_item" :class="activeId==109?'active':''" @click="goItem('联系联盟')">联系联盟</div>
                    </div>
                    <div class="mobile_menu_box_bottom_top">
                        <div class="mobile_menu_box_bottom_top_item" @click="changeLanguage">ENGLISH</div>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import $ from 'jquery'
import mobileKJudge from '../untils/mobile-judge'
import { newsTypeList } from '../untils/common-api'
export default {
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE_URL,
            categoryList: [
                {
                    id: 1,
                    name: '会议首页',
                    path: '/conference/index'
                },
                {
                    id: 101,
                    name: '大会介绍',
                    children: []
                },
                {
                    id: 102,
                    name: '大会嘉宾',
                    children: []
                },
                {
                    id: 103,
                    name: '大会笔记',
                    children: []
                },
                {
                    id: 104,
                    name: '参会参展',
                    children: []
                },
                {
                    id: 105,
                    name: '同期活动',
                    children: []
                },
                {
                    id: 106,
                    name: '赞助机会',
                    children: []
                },
                {
                    id: 107,
                    name: '下载中心',
                    children: []
                },
                {
                    id: 108,
                    name: '优秀品牌',
                    children: []
                },
                {
                    id: 109,
                    name: '联系联盟'
                }
            ],
            footerList: [],
            activeId: '',

            isOpenMenuMobile: false,
            topActiveNames: [],
            footerActiveNames: []
        }
    },
    // 是否为移动端
    computed: {
        isMobile() {
            return mobileKJudge()
        },
        // 获取当前路由
        currentPath() {
            return this.$route.path
        }
    },
    watch: {
        currentPath(val) {
            this.handlePath(val)
        }
    },
    created() {
        this.handlePath(this.$route.path)
        // 大会介绍
        this.getCategoryList('大会介绍', 101)
        // 大会嘉宾
        this.getCategoryList('大会嘉宾', 102)
        // 大会笔记
        this.getCategoryList('大会笔记', 103)
        // 参会参展
        this.getCategoryList('参会参展', 104)
        // 同期活动
        this.getCategoryList('同期活动', 105)
        // 赞助机会
        this.getCategoryList('赞助机会', 106)
        // 下载中心
        this.getCategoryList('下载中心', 107)
        // 优秀品牌
        this.getCategoryList('优秀品牌', 108)
    },
    methods: {
        handlePath(path) {
            // 判断path中是否有/conference/index或者/conference/list或者conference/details的字段
            if (path.indexOf('/conference/index') !== -1) {
                this.activeId = 1
            } else if (path.indexOf('/conference/list') !== -1) {
                const id = path.split('/')[3]
                this.activeId = id
                // this.topActiveNames = [id]
            } else if (path.indexOf('/conference/details') !== -1) {
                const id = path.split('/')[4]
                this.activeId = id
                // this.topActiveNames = [id]
            } else {
                this.activeId = ''
                // this.topActiveNames = []
            }
            if(this.activeId) {
                this.topActiveNames = [Number(this.activeId)]
            }
            // this.topActiveNames.push(this.activeId)
        },
        goMainIndex() {
            this.$router.push({ path: '/index' })
        },
        goPage(item) {
            if (item.id == 1) {
                this.$router.push({ path: '/conference/index' })
            } else if (item.id == 109) {
                window.location.href = '/#/conference/details/allice/109/0/0/1'
            }
            if(this.isMobile) {
                this.handleClose()
            }
        },
        changeLanguage() {
            if(this.isMobile) {
                this.handleClose()
            }
            // this.$router.push({ path: '/conference_en' })
            this.$message('英文版正在升级中，敬请期待！')
        },
        // 获取头部菜单
        async getCategoryList(name, type) {
            const res = await newsTypeList({
                model: type,
                lang: 1
            })
            if (res.code !== 1) return this.$message('信息获取失败，请稍后重试')
            if (res.data.records.length > 0) {
                this.categoryList.forEach(item => {
                    if (item.name === name) {
                        item.children = res.data.records
                    }
                })
                // this.categoryList删除第一个和最后三个赋值给footerList
                this.footerList = this.categoryList.slice(1, -3)
            }
        },
        goItem(name) {
            // 通过name在this.categoryList中找到对应的item
            const item = this.categoryList.find(item => item.name === name)
            if (item) {
                if (item.name == '下载中心' || item.name == '优秀品牌') {
                    if (item.children.length > 0) {
                        this.$router.push({
                            path: `/conference/list/${item.id}/${item.children[0].id}/1`
                        })
                    }
                } else if (item.name == '联系联盟') {
                    window.location.href =
                        '/#/conference/details/allice/109/0/0/1'
                } else {
                    if (item.children.length > 0) {
                        this.$router.push({
                            path: `/conference/list/${item.id}/${item.children[0].id}/1`
                        })
                    }
                }
            }
            if(this.isMobile) {
                this.handleClose()
            }
        },
        goList(item, item2) {
            this.$router.push({
                path: `/conference/list/${item.id}/${item2.id}/1`
            })
            if(this.isMobile) {
                this.handleClose()
            }
        },
        // 初始化下拉菜单
        initDropdown() {
            if (!this.isMobile) {
                // pc
                $('.menu_box').on('mouseover', '.header-item', function() {
                    $(this)
                        .find('.dropdown')
                        .stop()
                        .slideDown(300)
                    $(this)
                        .find('.el-icon-arrow-down')
                        .css({
                            transform: 'rotate(180deg)'
                        })
                })
                $('.menu_box').on('mouseout', '.header-item', function() {
                    $(this)
                        .find('.dropdown')
                        .stop()
                        .slideUp(300)
                    $(this)
                        .find('.el-icon-arrow-down')
                        .css({
                            transform: 'rotate(0)'
                        })
                })
            } else {
                // mobile
                $('.header-mobile-title').click(function() {
                    $('.header-mobile-content')
                        .stop()
                        .slideToggle(300)
                })
                $('.header-mobile-content').on(
                    'click',
                    '.dropdown',
                    function() {
                        $('.header-mobile-content')
                            .stop()
                            .slideToggle(300)
                    }
                )
                $('.header-mobile-content').on(
                    'click',
                    '.header-item>a',
                    function() {
                        $(this)
                            .parent()
                            .find('.dropdown')
                            .stop()
                            .slideToggle(300)
                        $(this)
                            .parent()
                            .siblings()
                            .find('.dropdown')
                            .stop()
                            .slideUp(300)
                        $(this)
                            .parent()
                            .siblings()
                            .find('.el-icon-arrow-right')
                            .css({
                                transform: ''
                            })
                        if (!$(this).find('.el-icon-arrow-right').length) {
                            $('.header-mobile-content')
                                .stop()
                                .slideToggle(300)
                        }
                        $(this)
                            .find('.el-icon-arrow-right')
                            .css({
                                transform:
                                    $(this).find('.el-icon-arrow-right')
                                        .length &&
                                    $(this).find('.el-icon-arrow-right')[0]
                                        .style.transform
                                        ? ''
                                        : 'rotate(90deg)'
                            })
                    }
                )
            }
        },
        openMenuMobile() {
            this.isOpenMenuMobile = true
        },
        handleClose() {
            this.$nextTick(() => {
                this.isOpenMenuMobile = false
            })
        },
    },
    mounted() {
        this.initDropdown()
        document.title = '国家动物健康与食品安全创新联盟'
    }
}
</script>
<style lang="less" scoped>
.conference {
    .header {
        width: 100%;
        .header_box {
            height: 104px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .header_left {
                width: 482px;
                height: 72px;
                cursor: pointer;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .header_right {
                display: flex;
                align-items: center;
                font-size: 16px;
                .header_right_item {
                    display: flex;
                    align-items: center;
                    color: #383838;
                    .header_right_item_left {
                        display: flex;
                        align-items: center;
                        margin-right: 10px;
                        margin-top: 1.5px;
                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .header_right_item_right {
                        color: #383838;
                    }
                    .header_right_item_eng {
                        color: #787878;
                    }
                }
                .header_right_line {
                    width: 1px;
                    height: 15px;
                    border-right: 1px solid #383838;
                    margin: 0 15px;
                }
                .header_right_item:last-child {
                    cursor: pointer;
                }
            }
        }
    }
    .menu {
        background-color: #0085d0;
        .menu_box {
            display: flex;
            justify-content: space-between;
            background-color: #0085d0;
            font-size: 18px;
            height: 56px;
            line-height: 56px;
            // margin-bottom: 30px;
            .header-item {
                flex: 1;
                position: relative;
                cursor: pointer;
                text-align: center;
                .header-item-name {
                    width: 100%;
                    color: #fff;
                    line-height: 55px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    > div {
                        // width: calc();
                        text-align: center;
                    }
                    .header-item-name-icon {
                        margin-right: 5px;
                    }
                    i {
                        font-size: 14px;
                        transition: transform 0.3s ease;
                    }
                }
                .dropdown {
                    box-sizing: border-box;
                    padding: 20px;
                    position: absolute;
                    left: 50%;
                    top: 56px;
                    transform: translateX(-50%);
                    display: inline-block;
                    min-width: 230px;
                    text-align: center;
                    color: #fff;
                    background-color: #ffffff;
                    box-shadow: 0px 0px 14px 0px rgba(29, 47, 71, 0.14);
                    display: none;
                    z-index: 99;
                    border-radius: 12px;
                    div {
                        color: #fff;
                        font-size: 18px;
                        height: 53px;
                        padding: 0 20px;
                        transition: background 0.3s ease;
                        cursor: pointer;
                        color: #000000;
                        border-radius: 12px;
                        margin-bottom: 10px;
                        &:hover {
                            background: #0085d0;
                            color: #ffffff;
                        }
                    }
                }
                &:last-child .dropdown {
                    left: auto;
                    right: 0;
                    transform: translateY(0);
                }
                .header-item-line {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 4px;
                    background: #39a516;
                    border-radius: 2px;
                }
            }
        }
    }
    .footer {
        width: 100%;
        .footer_bottom {
            background-color: #1d2f47;
            color: #ffffff;
            .footer_bottom_box {
                .footer_bottom_top {
                    display: flex;
                    justify-content: space-between;
                    padding: 100px 0 55px 0;
                    .footer_bottom_top_item {
                        .footer_bottom_top_item_top {
                            font-size: 18px;
                            font-weight: 600;
                            margin-bottom: 20px;
                            cursor: pointer;
                        }
                        .footer_bottom_top_item_box {
                            .footer_bottom_top_item_box_item {
                                margin-bottom: 15px;
                                display: flex;
                                cursor: pointer;
                            }
                        }
                        .footer_bottom_top_item_item {
                            font-size: 18px;
                            font-weight: 600;
                            margin-bottom: 20px;
                            cursor: pointer;
                        }
                        .footer_bottom_top_item_line {
                            width: 240px;
                            margin: 15px 0;
                            border-top: 2px solid rgba(38, 94, 191, 0.3);
                        }
                        .footer_bottom_top_item_bottom {
                            .footer_bottom_top_item_bottom_item {
                                margin-bottom: 5px;
                            }
                        }
                        .footer_bottom_top_right_right_box {
                            width: 120px;
                            height: 120px;
                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }
                }
                .footer_bottom_bottom {
                    font-size: 18px;
                    display: flex;
                    justify-content: center;
                    padding: 55px 0 100px 0;
                    border-top: 2px solid rgba(38, 94, 191, 0.3);
                    .footer_bottom_bottom_item {
                        margin-right: 40px;
                    }
                    .footer_bottom_bottom_item:last-child {
                        margin-right: 0;
                        cursor: pointer;
                    }
                }
            }
        }
    }
    .menu_mobile {
        .menu_mobile_box {
            .menu_mobile_box_box {
                padding: 0.2rem 0;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .menu_mobile_left {
                    width: calc(100% - 0.7rem);
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .menu_mobile_right {
                    width: 0.44rem;
                    height: 0.3rem;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }
    }
    .mobile_footer {
        .mobile_footer_menu {
            background-color: #1d2f47;
            padding: 0.5rem 0;
            color: #ffffff;
            .mobile_footer_menu_box {
                .mobile_footer_menu_top {
                    /deep/ .el-collapse {
                        border: none;
                        border-top: 1px solid #1f3d6c !important;
                        .el-collapse-item {
                            background-color: #1d2f47;
                            position: relative;
                            .el-collapse-item__header {
                                height: 1rem;
                                background-color: #1d2f47 !important;
                                border-color: #1f3d6c !important;
                                font-size: 0.3rem;
                                color: #ffffff !important;
                                display: flex;
                                align-items: center;
                                .el-collapse-item__arrow {
                                    font-size: 0.26rem;
                                }
                            }
                            .el-collapse-item__wrap {
                                background-color: #1d2f47 !important;
                                border-color: #1f3d6c !important;
                                .el-collapse-item__content {
                                    padding-bottom: 0.2rem;
                                    padding-left: 0.2rem;
                                    > div {
                                        display: flex;
                                        align-items: center;
                                        font-size: 0.26rem;
                                        margin-bottom: 0.2rem;
                                        color: #ffffff;
                                    }
                                }
                            }
                        }
                        .is-active {
                            .el-collapse-item__header {
                                border: none;
                            }
                            .el-collapse-item__content {
                                border: none;
                            }
                        }
                    }
                }
                .mobile_footer_menu_middle {
                    .mobile_footer_menu_middle_item {
                        height: 1rem;
                        display: flex;
                        align-items: center;
                        border-bottom: 1px solid #1f3d6c;
                        font-size: 0.3rem;
                    }
                }
                .mobile_footer_menu_bottom {
                    margin-top: 0.5rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    .mobile_footer_menu_bottom_item {
                        line-height: 1.5;
                    }
                    .mobile_footer_menu_bottom_first {
                        margin-bottom: 0.1rem;
                    }
                }
            }
        }
    }
    .el-drawer__wrapper {
        .el-drawer__container {
            .el-drawer__body {
                .mobile_menu_box {
                    width: 100%;
                    height: 100%;
                    padding: 0.3rem;
                    .mobile_menu_box_top {
                        i {
                            font-size: 0.5rem;
                        }
                    }
                    .mobile_menu_box_bottom {
                        .mobile_menu_box_bottom_top {
                            display: flex;
                            .mobile_menu_box_bottom_top_item {
                                height: 1rem;
                                line-height: 1rem;
                                font-size: 0.32rem;
                            }
                        }
                        .mobile_menu_box_bottom_bottom {
                            /deep/ .el-collapse {
                                border: none;
                                .el-collapse-item {
                                    position: relative;
                                    .el-collapse-item__header {
                                        height: 1rem;
                                        font-size: 0.3rem;
                                        color: #000000 !important;
                                        display: flex;
                                        align-items: center;
                                        .el-collapse-item__arrow {
                                            font-size: 0.26rem;
                                        }
                                    }
                                    .el-collapse-item__wrap {
                                        .el-collapse-item__content {
                                            padding-bottom: 0.2rem;
                                            padding-left: 0.2rem;
                                            > div {
                                                display: flex;
                                                align-items: center;
                                                font-size: 0.28rem;
                                                margin-bottom: 0.2rem;
                                                color: #000000;
                                            }
                                        }
                                    }
                                }
                                .is-active {
                                    .el-collapse-item__header {
                                        border: none;
                                        color: #0085d0!important;
                                    }
                                    .el-collapse-item__content {
                                        border: none;
                                    }
                                }
                            }
                            .menu_item {
                                font-size: 0.3rem;
                                height: 1rem;
                                line-height: 1rem;
                                border-bottom: 1px solid #e5e5e5;
                            }
                            .active {
                                color: #0085d0;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
